export const PENDING_AUTH_STATUS = 'pending';
export const SUCCESS_AUTH_STATUS = 'success';
export const ERROR_AUTH_STATUS = 'error';
export const ACCOUNT_LOCKED_AUTH_STATUS = 'locked';
export const UNDEFINED_AUTH_STATUS = '';

/* the `/session` data receiving statuses */
export const AUTH_DATA_NONE = 'none';
export const AUTH_DATA_PENDING = 'pending';
export const AUTH_DATA_RECEIVED = 'received';

/**
 * Checks that the status has been received from the server
 *
 * @param {string} status
 * @return {boolean}
 */
export function isAuthDataReceived(status) {
  return status === AUTH_DATA_RECEIVED;
}
